import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from '@/core/interfaces/store';
import { OVERLAY_STACK_TOP_Z_INDEX } from '@/core/constants/zIndex';

export interface ModalStackState {
  openOrder: Array<string>;
}

const initialState: ModalStackState = {
  openOrder: [],
};

export const modalStackSlice = createSlice({
  name: 'modalStack',
  initialState,
  reducers: {
    pushModal: (state, { payload }: PayloadAction<string>) => {
      const existing = state.openOrder.indexOf(payload);

      if (existing !== -1) state.openOrder.splice(existing, 1);
      state.openOrder.push(payload);
    },
    removeModal: (state, { payload }: PayloadAction<string>) => {
      const index = state.openOrder.indexOf(payload);

      if (index !== -1) state.openOrder.splice(index, 1);
    },
  },
});

export const { pushModal, removeModal } = modalStackSlice.actions;

const modalStackSelector = (state: RootState): ModalStackState => state.modalStack;

export const getModalZIndexSelector = createSelector(
  [
    modalStackSelector,
    (_state: RootState, id: string) => id,
    (_state: RootState, _id: string, baseZIndex: number = OVERLAY_STACK_TOP_Z_INDEX) => baseZIndex,
  ],
  (state, id, baseZIndex) => {
    const index = state.openOrder.indexOf(id);

    if (index === -1) return baseZIndex - 1;

    const distanceFromTop = state.openOrder.length - 1 - index;

    return baseZIndex - distanceFromTop;
  }
);

export default modalStackSlice.reducer;
